import React from "react";

import { Doughnut } from 'react-chartjs-2';

import ModulePanel from "../../ModulePanel";
import styled from "styled-components";

const ThirdChart = ({nps, surveys})=>{
    const [individualScore, setIndividualScore] = React.useState([]);

    React.useEffect(()=>{
        const counter = {
            c0: 0,
            c1: 0,
            c2: 0,
            c3: 0,
            c4: 0,
            c5: 0,
            c6: 0,
            c7: 0,
            c8: 0,
            c9: 0,
            c10: 0
        };
        surveys.forEach((survey)=>{
            if (typeof survey.findings === "number"){
                counter[`c${survey.findings}`]++;
            }
        });

        setIndividualScore([counter.c0, counter.c1, counter.c2, counter.c3, counter.c4, counter.c5, counter.c6, counter.c7, counter.c8, counter.c9, counter.c10]);
    }, [surveys]);

    const data = {
        labels: [
            'Detractores',
            'Promotores',
            'Pasivos'
        ],
        datasets: [{
            data: [nps.detractor, nps.promotor, nps.passive],
            backgroundColor: [
                '#F44336',
                '#4CAF50',
                '#FFEB3B'
            ],
            hoverBackgroundColor: [
                '#BA000D',
                '#087F23',
                '#C8B900'
            ],
            textBackgroundColor: [
                "#FF0000",
                "#FF0000",
                "#FF0000"
            ]
        }]
    };

    return (
        <ModulePanel title={["NPS"]}>
            <BarContainer>
                {individualScore.map((score, index)=>{
                    const 
                        emoji = (index > 6 ? (index > 8 ? "fas fa-smile" : "fas fa-meh") : "fas fa-frown"),
                        _class = (index > 6 ? (index > 8 ? "success" : "warning") : "danger");

                    return (
                        <div key={index}>
                            <i className={emoji + " text-" + _class} />
                            <label>{score}</label>
                            <span>
                                <span>{index}</span>
                            </span>
                        </div>
                    )
                })}
            </BarContainer>
            <div className="row text-center d-flex align-items-center">
                <div className="col-md-3">
                    <Doughnut data={data} options={{
                        legend: {
                            display: false
                        }, 
                        elements: {
                            arc: {
                                borderWidth: 10,
                            }
                        },
                    }} />
                    <h1><small>NPS: </small>{(((nps.promotor / nps.total) - (nps.detractor / nps.total)) * 100).toFixed(0)}</h1>
                    <h6 className="text-muted">NPS = % Promotores - % Detractores</h6>
                </div>
                <div className="col-md-7">
                    <div className="d-flex justify-content-between">
                        <div className="flex-1">
                            <label className="badge badge-danger">Detractores</label>
                        </div>
                        <div className="flex-1">
                            <label className="badge badge-danger">{nps.detractor}</label>
                        </div>
                        <div className="flex-1">
                            <label className="badge badge-danger">{((nps.detractor / nps.total) * 100).toFixed(0)}%</label>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between">
                        <div className="flex-1">
                            <label className="badge badge-warning">Pasivos</label>
                        </div>
                        <div className="flex-1">
                            <label className="badge badge-warning">{nps.passive}</label>
                        </div>
                        <div className="flex-1">
                            <label className="badge badge-warning">{((nps.passive / nps.total) * 100).toFixed(0)}%</label>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between">
                        <div className="flex-1">
                            <label className="badge badge-success">Promotores</label>
                        </div>
                        <div className="flex-1">
                            <label className="badge badge-success">{nps.promotor}</label>
                        </div>
                        <div className="flex-1">
                            <label className="badge badge-success">{((nps.promotor / nps.total) * 100).toFixed(0)}%</label>
                        </div>
                    </div>
                </div>

                <div className="col-md-2">
                    <h4>TOTAL</h4>
                    <h2>{nps.total}</h2>
                </div>
            </div>
        </ModulePanel>

    )
}

export default ThirdChart;

const BarContainer = styled.div`
    margin-bottom: 1rem;
    
    & > div{
        display: inline-block;
        width: 9%;
        text-align: center;
    }

    & > div > *{
        display: block;
    }

    & > div > label{
        background: rgba(0, 0, 0, 0.84);
        border-radius: 8px;
        color: white;
        font-size: 10px;
        display: inline-block;
        margin: 8px auto;
        padding:0 12px;
    }
    & > div > span{
        color: white;
    }

    & > div:first-child > span{
        border-bottom-left-radius: 8px;
        border-top-left-radius: 8px;
    }

    & > div:last-child > span{
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
    }
    & > div:nth-child(-n+7) span{
        background: var(--danger);
        
    }

    & > div:nth-child(8) span,
    & > div:nth-child(9) span{
            background: var(--warning);
    }

    & > div:nth-child(10n) span,
    & > div:nth-child(11n) span{
        background: var(--success);
    }

    & > div > i{
        font-size: 36px;
    }
    & > div > span{
        
    }
    & > div > span > span{
        border-radius: 80px;
        padding: 6px 10px;
    }

    @media(max-width: 520px){
        & > div > i{
            font-size:30px;
        }   
    }

    @media(max-width: 420px){
        & > div > i{
            font-size:24px;
        }   
    }
`;